import { getStrByLang } from '@/utils'

export const formatterItem = {
  type: 'value', // auto,value,percent
  unit: 1, // 换算单位
  suffix: '', // 单位后缀
  decimalCount: 2, // 小数位数
  thousandSeparator: true// 千分符
}

// 单位list
export const unitList = [
  { name: 'unit_none', value: 1 },
  { name: 'unit_thousand', value: 1000 },
  { name: 'unit_ten_thousand', value: 10000 },
  { name: 'unit_million', value: 1000000 },
  { name: 'unit_hundred_million', value: 100000000 }
]

// 格式化方式
export const formatterType = [
  { name: 'value_formatter_auto', value: 'auto' },
  { name: 'value_formatter_value', value: 'value' },
  { name: 'value_formatter_percent', value: 'percent' }
]

export function valueFormatter(value, formatter) {
  //柱状图、折线图支持结果隐藏空数据
  if (value === null || value === undefined) {
    return null
  }
  // 1.unit 2.decimal 3.thousand separator and suffix
  let result
  if (formatter.type === 'auto') {
    result = transSeparatorAndSuffix(transUnit(value, formatter), formatter)
  } else if (formatter.type === 'value') {
    result = transSeparatorAndSuffix(transDecimal(transUnit(value, formatter), formatter), formatter)
  } else if (formatter.type === 'percent') {
    value = value * 100
    result = transSeparatorAndSuffix(transDecimal(value, formatter), formatter)
  } else {
    result = value
  }
  return result
}

function transUnit(value, formatter) {
  return value / formatter.unit
}

function transDecimal(value, formatter) {
  return value.toFixed(formatter.decimalCount)
}

function transSeparatorAndSuffix(value, formatter) {
  let str = value + ''
  if (formatter.thousandSeparator) {
    const thousandsReg = /(\d)(?=(\d{3})+$)/g
    const numArr = str.split('.')
    numArr[0] = numArr[0].replace(thousandsReg, '$1,')
    str = numArr.join('.')
  }
  if (formatter.type === 'percent') {
    str += '%'
  } else {
    if (formatter.unit === 1000) {
      const unit_thousand = '~~`7 千`~`8 k`~`~'
      str += getStrByLang(unit_thousand)
    } else if (formatter.unit === 10000) {
      const unit_ten_thousand = '~~`7 万`~`8 10K`~`~'
      str += getStrByLang(unit_ten_thousand)
    } else if (formatter.unit === 1000000) {
      const unit_million = '~~`7 百万`~`8 million`~`~'
      str += getStrByLang(unit_million)
    } else if (formatter.unit === 100000000) {
      const unit_hundred_million = '~~`7 亿`~`8 hundred_million`~`~'
      str += getStrByLang(unit_hundred_million)
    }
  }
  return str + formatter.suffix.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * 不添加后缀的格式转换
 * @param value
 * @param formatter
 * @returns {*}
 */
export function valueFormatterWithoutSuffix(value, formatter) {
  let result
  if (formatter.type === 'auto') {
    result = transSeparator(transUnit(value, formatter), formatter)
  } else if (formatter.type === 'value') {
    result = transSeparator(transDecimal(transUnit(value, formatter), formatter), formatter)
  } else if (formatter.type === 'percent') {
    value = value * 100
    result = transSeparator(transDecimal(value, formatter), formatter)
  } else {
    result = value
  }
  return result
}

/**
 * 转换分隔符，不添加中文后缀
 * @param value
 * @param formatter
 * @returns {string}
 */
function transSeparator(value, formatter) {
  let str = value + ''
  if (formatter.thousandSeparator) {
    const thousandsReg = /(\d)(?=(\d{3})+$)/g
    const numArr = str.split('.')
    numArr[0] = numArr[0].replace(thousandsReg, '$1,')
    str = numArr.join('.')
  }
  return str + formatter.suffix.replace(/(^\s*)|(\s*$)/g, '')
}

